import styles from './index.module.less'
import loading1 from '@/assets/loading-01.png';
import loading2 from '@/assets/loading-02.png';
import { useEffect, useState, useCallback } from 'react';
import { Button, Form, Field as FusionField } from '@b-design/fusion';
import classNames from 'classnames';

const LoadingIcon = ({ type, loading }) => {
  return (
     <div className={styles.loadingIcon}>
        <img src={ type === 'primary' ? loading2 : loading1 }/>  
      </div>
  );
}
const CustomButton = ({ type, onClick, className, noLoading, loading, ...props }) => {
  const [curLoading, setCurLoading] = useState(loading || false);
  useEffect(() => {
    setCurLoading(loading);
  },[loading])

  const handleClick = useCallback(
    async (event: React.MouseEvent<HTMLButtonElement>) => {
      try {
        !noLoading && setCurLoading(true);
        await onClick(event);
      } finally {
        !noLoading && setCurLoading(false);
      }
    },
    [onClick, noLoading]
  );
  return <Button className={classNames(styles.customButton, className)} loading={curLoading} type={type} onClick={handleClick} icons={{loading: <LoadingIcon type={type} loading={loading}/>}} {...props} />
}

export const FormSubmit = ({ type, noLoading, onClick, loading, className, ...props }) => {
  const [curLoading, setCurLoading] = useState(loading || false);
  useEffect(() => {
    setCurLoading(loading);
  },[loading])
  const handleClick = useCallback(
    async (...args) => {
      try {
        !noLoading && setCurLoading(true);
        await onClick(...args);
      } finally {
        !noLoading && setCurLoading(false);
      }
    },
    [onClick, noLoading]
  );
  return (
    <Form.Submit className={classNames(styles.customButton, className)} onClick={handleClick} loading={curLoading} type={type} icons={{loading: <LoadingIcon type={type} loading={loading}/>}} {...props}></Form.Submit>
  )
}

type ValidateResult<T> = [Error | null, T | null];

export function promisifyValidate<T = any>(
  field: FusionField,
  names?: string | string[],
): Promise<ValidateResult<T>> {
  return new Promise((resolve) => {
    if (names) {
      field.validate(names, (err, values) => {
        resolve([err, values as T]);
      });
    } else {
      field.validate((err, values) => {
        resolve([err, values as T]);
      });
    }
  });
}



export default CustomButton;